































































































































































































































































































import { Component, Vue } from "vue-property-decorator";
import { readAdminOneUser } from "@/store/admin/getters";
import { dispatchGetUsers } from "@/store/admin/actions";

@Component
export default class ViewUser extends Vue {
  public loading = true;
  public async mounted() {
    this.loading = true;
    await Promise.allSettled([dispatchGetUsers(this.$store)]);
    this.loading = false;
  }

  public cancel() {
    this.$router.back();
  }

  public edit() {
    this.$router.push({
      name: "main-admin-users-edit",
      params: { id: this.$router.currentRoute.params.id },
    });
  }
  get user() {
    return readAdminOneUser(this.$store)(+this.$router.currentRoute.params.id);
  }
}
